"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _HTTPValidationError = _interopRequireDefault(require("../model/HTTPValidationError"));
var _Stellenanzeige = _interopRequireDefault(require("../model/Stellenanzeige"));
var _StellenanzeigeCreate = _interopRequireDefault(require("../model/StellenanzeigeCreate"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * KFV LDS API
 * Die KFV LDS API bietet eine Schnittstelle zum Backend der PWA.
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
* Stellenanzeigen service.
* @module api/StellenanzeigenApi
* @version 0.0.1
*/
class StellenanzeigenApi {
  /**
  * Constructs a new StellenanzeigenApi. 
  * @alias module:api/StellenanzeigenApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  constructor(apiClient) {
    this.apiClient = apiClient || _ApiClient.default.instance;
  }

  /**
   * Callback function to receive the result of the createStellenanzeigeStellenanzeigePost operation.
   * @callback module:api/StellenanzeigenApi~createStellenanzeigeStellenanzeigePostCallback
   * @param {String} error Error message, if any.
   * @param {module:model/Stellenanzeige} data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * Create Stellenanzeige
   * @param {module:model/StellenanzeigeCreate} stellenanzeigeCreate 
   * @param {module:api/StellenanzeigenApi~createStellenanzeigeStellenanzeigePostCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link module:model/Stellenanzeige}
   */
  createStellenanzeigeStellenanzeigePost(stellenanzeigeCreate, callback) {
    let postBody = stellenanzeigeCreate;
    // verify the required parameter 'stellenanzeigeCreate' is set
    if (stellenanzeigeCreate === undefined || stellenanzeigeCreate === null) {
      throw new Error("Missing the required parameter 'stellenanzeigeCreate' when calling createStellenanzeigeStellenanzeigePost");
    }
    let pathParams = {};
    let queryParams = {};
    let headerParams = {};
    let formParams = {};
    let authNames = ['JWTBearer'];
    let contentTypes = ['application/json'];
    let accepts = ['application/json'];
    let returnType = _Stellenanzeige.default;
    return this.apiClient.callApi('/stellenanzeige/', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
  }

  /**
   * Callback function to receive the result of the deleteStellenanzeigeStellenanzeigeStellenanzeigeIdDelete operation.
   * @callback module:api/StellenanzeigenApi~deleteStellenanzeigeStellenanzeigeStellenanzeigeIdDeleteCallback
   * @param {String} error Error message, if any.
   * @param {Object} data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * Delete Stellenanzeige
   * @param {Number} stellenanzeigeId 
   * @param {module:api/StellenanzeigenApi~deleteStellenanzeigeStellenanzeigeStellenanzeigeIdDeleteCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link Object}
   */
  deleteStellenanzeigeStellenanzeigeStellenanzeigeIdDelete(stellenanzeigeId, callback) {
    let postBody = null;
    // verify the required parameter 'stellenanzeigeId' is set
    if (stellenanzeigeId === undefined || stellenanzeigeId === null) {
      throw new Error("Missing the required parameter 'stellenanzeigeId' when calling deleteStellenanzeigeStellenanzeigeStellenanzeigeIdDelete");
    }
    let pathParams = {
      'stellenanzeige_id': stellenanzeigeId
    };
    let queryParams = {};
    let headerParams = {};
    let formParams = {};
    let authNames = ['JWTBearer'];
    let contentTypes = [];
    let accepts = ['application/json'];
    let returnType = Object;
    return this.apiClient.callApi('/stellenanzeige/{stellenanzeige_id}', 'DELETE', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
  }

  /**
   * Callback function to receive the result of the getStellenanzeigenStellenanzeigeGet operation.
   * @callback module:api/StellenanzeigenApi~getStellenanzeigenStellenanzeigeGetCallback
   * @param {String} error Error message, if any.
   * @param {Array.<module:model/Stellenanzeige>} data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * Get Stellenanzeigen
   * @param {module:api/StellenanzeigenApi~getStellenanzeigenStellenanzeigeGetCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link Array.<module:model/Stellenanzeige>}
   */
  getStellenanzeigenStellenanzeigeGet(callback) {
    let postBody = null;
    let pathParams = {};
    let queryParams = {};
    let headerParams = {};
    let formParams = {};
    let authNames = [];
    let contentTypes = [];
    let accepts = ['application/json'];
    let returnType = [_Stellenanzeige.default];
    return this.apiClient.callApi('/stellenanzeige/', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
  }

  /**
   * Callback function to receive the result of the updateStellenanzeigeStellenanzeigeStellenanzeigeIdPatch operation.
   * @callback module:api/StellenanzeigenApi~updateStellenanzeigeStellenanzeigeStellenanzeigeIdPatchCallback
   * @param {String} error Error message, if any.
   * @param {module:model/Stellenanzeige} data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * Update Stellenanzeige
   * @param {Number} stellenanzeigeId 
   * @param {module:model/StellenanzeigeCreate} stellenanzeigeCreate 
   * @param {module:api/StellenanzeigenApi~updateStellenanzeigeStellenanzeigeStellenanzeigeIdPatchCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link module:model/Stellenanzeige}
   */
  updateStellenanzeigeStellenanzeigeStellenanzeigeIdPatch(stellenanzeigeId, stellenanzeigeCreate, callback) {
    let postBody = stellenanzeigeCreate;
    // verify the required parameter 'stellenanzeigeId' is set
    if (stellenanzeigeId === undefined || stellenanzeigeId === null) {
      throw new Error("Missing the required parameter 'stellenanzeigeId' when calling updateStellenanzeigeStellenanzeigeStellenanzeigeIdPatch");
    }
    // verify the required parameter 'stellenanzeigeCreate' is set
    if (stellenanzeigeCreate === undefined || stellenanzeigeCreate === null) {
      throw new Error("Missing the required parameter 'stellenanzeigeCreate' when calling updateStellenanzeigeStellenanzeigeStellenanzeigeIdPatch");
    }
    let pathParams = {
      'stellenanzeige_id': stellenanzeigeId
    };
    let queryParams = {};
    let headerParams = {};
    let formParams = {};
    let authNames = ['JWTBearer'];
    let contentTypes = ['application/json'];
    let accepts = ['application/json'];
    let returnType = _Stellenanzeige.default;
    return this.apiClient.callApi('/stellenanzeige/{stellenanzeige_id}', 'PATCH', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
  }
}
exports.default = StellenanzeigenApi;